import { SVGProps } from 'react';

import { cn } from '@ui/lib/utils';
import { FC } from 'react';

/* StreetAddress Icon */
export const StreetAddressIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <circle
      cx="12"
      cy="10"
      r="3"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></circle>
  </svg>
);

/* Suburb Icon Red */
export const SuburbIconRed: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M5.6507 2.87087C4.2001 4.29254 3.2949 6.15676 3.08664 8.15119C2.87836 10.1457 3.37977 12.1493 4.50675 13.8265L10.8291 23.1763C10.9535 23.3609 11.1231 23.5124 11.3225 23.6173C11.5219 23.7221 11.745 23.7771 11.9716 23.7771C12.1983 23.7771 12.4213 23.7221 12.6207 23.6173C12.8201 23.5124 12.9898 23.3609 13.1142 23.1763L19.4365 13.8265C20.653 12.0247 21.1406 9.84724 20.8047 7.71534C20.4688 5.58356 19.3333 3.64887 17.6179 2.28569C15.9027 0.922537 13.7295 0.227803 11.5189 0.335911C9.30823 0.444018 7.21732 1.34727 5.6507 2.87087ZM11.973 14.2103C10.9071 14.2105 9.86513 13.9026 8.9788 13.3256C8.09248 12.7486 7.40157 11.9285 6.99364 10.969C6.5856 10.0094 6.47884 8.95343 6.68677 7.93466C6.8947 6.91601 7.40794 5.98021 8.16171 5.24576C8.91537 4.5113 9.87574 4.01113 10.9212 3.80856C11.9666 3.60599 13.0502 3.70996 14.035 4.1075C15.0197 4.50505 15.8614 5.17831 16.4534 6.04196C17.0455 6.90562 17.3615 7.92104 17.3614 8.95968C17.3614 10.3523 16.7937 11.6878 15.7832 12.6725C14.7727 13.6572 13.4022 14.2103 11.973 14.2103Z"
      fill="#FF5349"
    />
  </svg>
);

/* Phone Icon */
export const PhoneIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M17.2777 1.97344L20.7457 2.35877C21.6754 2.46207 22.3924 3.19943 22.2947 4.12973C22.0507 6.4554 20.9013 11.0411 15.9719 15.9705C11.0426 20.8998 6.45629 22.0499 4.13019 22.2943C3.19972 22.3921 2.46212 21.6751 2.3588 20.7452L1.97351 17.2776C1.88544 16.485 2.27671 15.7158 2.96921 15.3202L5.45331 13.9011C6.23635 13.4538 7.22191 13.5858 7.85959 14.2235L8.49687 14.8608C8.96972 15.3336 9.65114 15.5337 10.2555 15.2474C10.9715 14.9082 12.0065 14.2791 13.1428 13.1427C14.2792 12.0064 14.9083 10.9715 15.2475 10.2554C15.5338 9.65107 15.3337 8.96964 14.8608 8.4968L14.2236 7.85951C13.5859 7.22184 13.4538 6.23628 13.9012 5.45323L15.3202 2.96914C15.7158 2.27664 16.4851 1.88537 17.2777 1.97344Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* Email Icon */
export const EmailIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M19 4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H19C19.7956 20 20.5587 19.6839 21.1213 19.1213C21.6839 18.5587 22 17.7956 22 17V7C22 6.20435 21.6839 5.44129 21.1213 4.87868C20.5587 4.31607 19.7956 4 19 4V4ZM5 6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7L12 11.88L4 7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6V6ZM20 17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17V9.28L11.48 13.85C11.632 13.9378 11.8045 13.984 11.98 13.984C12.1555 13.984 12.328 13.9378 12.48 13.85L20 9.28V17Z"
      fill="currentColor"
    />
  </svg>
);
